import { css } from '@emotion/react';
import * as React from 'react';

import { mediaUp } from '../../../theme/breakpoints';

const containerCss = css`
  width: 100%;
  padding-right: 0.75rem;
  padding-left: 0.75rem;
  margin-right: auto;
  margin-left: auto;

  ${mediaUp('sm')} {
    max-width: 540px;
  }
  ${mediaUp('md')} {
    max-width: 768px;
  }
  ${mediaUp('lg')} {
    max-width: 960px;
  }
  ${mediaUp('xl')} {
    max-width: 1140px;
  }
  ${mediaUp('xxl')} {
    max-width: 1380px;
  }
  ${mediaUp('xxxl')} {
    max-width: 1800px;
  }
`;

export type ContainerProps = React.HTMLAttributes<HTMLDivElement>;

const Container = ({ className, children, ...rest }: ContainerProps): React.JSX.Element => (
  <div css={containerCss} className={className} {...rest}>
    {children}
  </div>
);

export default Container;
